import React from "react";
import { createEnumDelimitedArrayParam } from "serialize-query-params";
import { useQueryParam } from "use-query-params";
import { ArAgingBucket } from "@common/types/reports/ar-aging";
import { ArAgingDetailReport } from "./ArAgingDetailReport";

const BucketsParam = createEnumDelimitedArrayParam(
    Object.values(ArAgingBucket),
    ",",
);

export const ArAgingDetailPage: React.FC = () => {
    // `buckets` only applies to Detail (Summary drilldown scopes to one
    // bucket's section via a single-element array). The standalone page is
    // also reachable from the reports list, so `buckets` stays a normal
    // editable query param rather than a one-time seed — same as
    // EliminationDetail's `accountCode`.
    const [bucketsParam, setBucketsParam] = useQueryParam(
        "buckets",
        BucketsParam,
    );
    // A stale or malformed URL (e.g. `?buckets=current,bogus`) decodes unknown
    // values to `null`; drop them so only valid buckets reach the request
    // schema instead of the whole report being rejected.
    const buckets = bucketsParam?.filter(
        (bucket): bucket is ArAgingBucket => bucket !== null,
    );

    return (
        <ArAgingDetailReport
            buckets={buckets}
            onBucketsChange={setBucketsParam}
        />
    );
};
